<!--
 * @Author: LiZhiWei
 * @Date: 2026-06-02 10:51:32
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-06-02 13:03:37
 * @Description: 
-->
<template>
  <section
    id="pain-points"
    ref="painPointsSection"
    class="landing-container lt-sm:px-32px scroll-mt-70px py-112px lt-sm:py-120px bg-white transition-all duration-1000 ease-out"
    :class="[isPainPointsVisible ? 'translate-y-0 opacity-100' : 'translate-y-50px opacity-0']"
    data-section
  >
    <section-heading
      title="让物业管理，从繁杂走向高效"
      description="从档案、收费到巡检、报修和多项目经营，绘管家把分散流程重新串成一个可追踪、可复盘的运营闭环。"
    />

    <div
      class="mt-96px gap-20px lt-sm:mt-120px lt-sm:grid-cols-2 lt-sm:grid-cols-1 lt-sm:gap-88px grid grid-cols-4"
    >
      <article
        v-for="item in painPoints"
        :key="item.title"
        class="group min-h-217px rounded-16px border-#e2e8f0 px-24px pb-24px pt-67px hover:-translate-y-4px hover:border-#bfd6ff lt-sm:min-h-390px lt-sm:px-24px lt-sm:pt-108px relative border bg-white transition-all duration-220 hover:shadow-[0_16px_40px_rgba(15,23,42,0.06)]"
      >
        <span
          class="h-128px w-128px lt-sm:h-188px lt-sm:w-188px lt-sm:top-[-95px] absolute top-[-65px] left-0 transition-transform duration-300 group-hover:translate-y-[-4px]"
        >
          <img class="h-full w-full object-contain" :src="item.icon" :alt="item.title" />
        </span>
        <h3
          class="pf-sc-semibold mb-19px font-s-22px text-#0f172a lt-sm:font-s-32px lt-sm:leading-[40px] m-0 leading-[1.16]"
        >
          {{ item.title }}
        </h3>
        <p
          class="pf-sc-regular font-s-16px text-#64748b lt-sm:font-s-24px lt-sm:leading-[36px] m-0 leading-[1.65] break-words"
        >
          {{ item.text }}
        </p>
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
  import SectionHeading from '../section-heading.vue'

  import { painPoints } from '~/constants/huiguanjia-home'

  defineOptions({
    name: 'PainPointsSection',
  })

  const painPointsSection = useTemplateRef<HTMLElement>('painPointsSection')
  const { isVisible: isPainPointsVisible } = useScrollReveal(painPointsSection)
</script>

<style scoped>
  .pain-solution-list::-webkit-scrollbar {
    display: none;
  }

  @screen lt-sm {
    .pain-dot {
      width: 60px;
      height: 10px;
    }

    .pain-dot.active {
      background-color: #0f67f8 !important;
    }
  }
</style>
